import { FC } from 'react'
import { useProfile } from '../../hooks/use-profile'
import { SettingsProfileInfoCustomerMode } from './settings-profile-info-customer-mode'
import { SettingsProfileInfoPersonalMode } from './settings-profile-info-personal-mode'
import type { SettingsProfileInfoProps } from './settings-profile-info.interface'

export const SettingsProfileInfo: FC<SettingsProfileInfoProps> = ({ profileInfo, preferences }) => {
  const { isLoading, data } = useProfile()

  if (isLoading) return null

  return data.usage_mode === 'personal' ? (
    <SettingsProfileInfoPersonalMode profileInfo={profileInfo} preferences={preferences} />
  ) : (
    <SettingsProfileInfoCustomerMode profileInfo={profileInfo} preferences={preferences} />
  )
}
